import type { InputHTMLAttributes, ReactNode } from 'react';

import type { ValueOf } from 'cpool-utils';

import type { EventBehaviorProps } from '../../utils/EventBehavior';

export const CheckboxSize = {
    LARGE: 'large',
    MEDIUM: 'medium',
} as const;

export type CheckboxSizeType = ValueOf<typeof CheckboxSize>;

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>, EventBehaviorProps {
    size?: CheckboxSizeType;
    label?: ReactNode;
    description?: ReactNode;
    labelClassName?: string;
    descriptionClassName?: string;
    id: string;
}
